import React from 'react'
import { Button } from '@mui/material'

const UpdateButton = (props) => {
    const { text } = props
    const buttonText = text === 'new' ? 'Create Recipe' : 'Update Recipe'

    return (
        <Button variant="outlined" type="submit">{buttonText}</Button>
    );
}

export default UpdateButton